import { formatValue } from "../Performance Dashboard/MetricCard";

interface ValueDisplayProps {
    value: number;
    showSign?: boolean;
}

const ValueDisplay: React.FC<ValueDisplayProps> = ({ value, showSign = true }) => {

const formatValueWithSignAndColor = (value: number, showSign: boolean) => {
    if (isNaN(value)) {
        return {
            formattedValue: "-", 
            style: {
                color: "black",
                backgroundColor: "#f0f0f0",
                padding: "4px 8px",
            },
        };
    }
    let formattedValue = formatValue(value);
    let style = {
        color: 'black',
        backgroundColor: '#d3d3d3',
        padding: '4px 8px',
    };

    if (showSign) {
        const isPositive = value > 0;
        const isZero = value === 0;
        const sign = (isPositive || isZero) ? '+' : ''; 
        const color = isZero ? 'green' : isPositive ? 'red' : 'green';
        const backgroundColor = isPositive ? '#FFCCCC' : '#CCFFCC';

        formattedValue = `${sign}${formattedValue}`;
        style = {
            color,
            backgroundColor,
            padding: '4px 8px',
        };
    }

    return {
        formattedValue,
        style,
    };
};
    
    const { formattedValue, style } = formatValueWithSignAndColor(value, showSign);
    
    return <p style={{ margin: 0, ...style }}>{formattedValue}</p>;
};

export default ValueDisplay;
